import React from 'react';
import styled from 'styled-components'
import PropTypes from 'prop-types';
import {Box, Flex, Text, Card} from "rebass";
import {Avatar} from "reakit";
import {minHeight, minWidth} from "styled-system";

export const CardWrapper = styled(Card)`
${minWidth}
${minHeight}
display: flex;
justify-content: center;
box-shadow: rgba(0, 0, 0, 0.16) 0px 0px 6px;
  transition: all 0.5s ease;
`

const SettingProfileCard = (props) => {
    const { detail } = props;
    const name =  `${detail.first_name} ${detail.last_name}`
    const { profile_pic } = detail;
    return (
            <CardWrapper 
                {...props}
                minHeight={[1/2, '153px']}
                minWidth={[1/2, '153px']}
                justifyContent={'center'}
                variant='user'
            >
                <Flex flexWrap={'wrap'} flexDirection={['column']}  justifyContent={'center'}>
                    <Box width={[1, 'auto']}>
                        <Flex flexDirection={'column'}>
                            <Flex justifyContent={'center'}>
                                <Avatar src={profile_pic} width={'60px'} height={'60px'} backgroundColor={'#707070'}/>
                            </Flex>
                        </Flex>
                    </Box>
                    <Box width={[1, 'auto']}>
                        <Text textAlign={'center'} fontSize={'15px'} fontWeight='600' pt={2}>
                            {name}
                        </Text>
                        <Text color={'metaText'} textAlign={'center'} fontSize={'15px'} fontWeight='600' pt={2}>
                            Click to Configure
                        </Text>
                    </Box>
                </Flex>
            </CardWrapper>    
    )
}

SettingProfileCard.propTypes = {
    detail: PropTypes.object,
}

export default SettingProfileCard;